import React from "react";

import Default from "../dashboards/Default";

// Access is enforced by AuthGuard in routes.js
function ProtectedPage() {
  return <Default />;
}

export default ProtectedPage;
